// import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';

function init() {

	var $businessIntro = $('.business-intro');
	// var $maplink;

	if (!$businessIntro.length) {
		return;
	}

	// $maplink = $businessIntro.find('.business-intro__maplink');
	// $maplink.attr('href', $maplink.data('href'));

	$businessIntro.on('mousedown', '.business-intro__maplink', function() {
		window.setTimeout(() => { document.location.href = this.href; }, 150);
	});

	$businessIntro.on('mousedown', '.business-intro__footer-back', function() {
		window.setTimeout(() => { window.history.go(-1); }, 150);
	});

	// Trigger stats
	//galaxoStats.send('business_page', $('.business-intro__title').text());

}

export default {
	init
};
